import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import cardService from "../../../services/CardService";
import playlistService from "../../../services/PlaylistService";
import { urlExists, downloadBlob } from "../../Global/tools.js";

//Components
import NanoFlex from "../../Global/NanoFlex.js";
import Loading from "./../../Nano/Loading.js";
import Type from "./../../Global/Typography.js";
import Modal from "../../Global/Modal.js";
import PlaylistModal from "../../Micro/PlaylistModal.js";
import Button from "../../Nano/Buttons/Button.js";
import SingleSelectionDropdown from "../../Nano/SingleSelectionDropdown.js";
import MultiSelectionDropdown from "../../Nano/MultipleSelectionDropdown.js";

//Blocks
import ProgrammeImageBlock from "./Partials/ProgrammeImageBlock.js";
import GenreConceptBlock from "./Partials/GenreConceptBlock.js";
import CardInfoBlock from "./Partials/CardInfoBlock.js";
import CountryBlock from "./Partials/CountryBlock.js";
import FormatTypeBlock from "./Partials/FormatTypeBlock.js";
import InternationalFlowBlock from "./Partials/InternationalFlowBlock.js";
import AudienceResultsBlock from "./Partials/AudienceResultsBlock.js";
import EnvironmentBlock from "./Partials/EnvironmentBlock.js";
import ThumbsBlock from "./Partials/ThumbsBlock.js";
import SourceBlock from "./Partials/SourceBlock.js";
import EvaluationBlock from "./Partials/EvaluationBlock.js";
import VerdictBlock from "./Partials/VerdictBlock.js";

import { ReactComponent as ErrorLogo } from "../../Global/Icons/errorLogo.svg";
import { ReactComponent as Check } from "../../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const StyledCard = styled.div`
  width: 100%;
  padding: ${multiple * 2 + "px"}; /* 16px */

  .column {
    margin-right: ${multiple * 2 + "px"};

    &:last-child {
      margin-right: 0;
    }
  }
  .columnWrapper {
    margin-right: ${multiple + "px"}; /* 8px */
    .rowContainer {
      margin-bottom: 12px;
    }
    .difListWrapper {
      margin: 0;
      box-shadow: none;
      padding: 0;
      border: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }

  .titleContainer {
    margin-left: 0;
    width: auto;
  }

  .wrapperList {
    margin-top: 0;
    .listRow {
      padding: ${multiple + "px"} ${multiple + "px"} ${multiple * 2 + "px"} ${multiple + "px"};
    }
  }

  .titleWrapper {
    .secondaryTitleWrapper {
      h4 {
        font-size: 12px;
      }
    }
  }

  .infoContainer {
    margin-bottom: ${multiple + "px"};
    .titleInfo {
      text-transform: uppercase;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .clickableSearch {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  /* @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
    .cardWrapper {
      flex-direction: column;
      .cardInfoWrapper {
        margin-bottom: 8px;
      }
    }
    .blocksContainer {
      flex-direction: row;
      align-content: stretch;
      align-items: stretch;
      .rowContainer {
        align-content: stretch;
        align-items: stretch;
        height: auto;
        margin-right: 8px;
        .countryCard {
          height: 100%;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  } */

  @media only screen and (max-width: 800px) {
    .columnWrapper {
      .rowContainer {
        margin-bottom: 16px;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .columnWrapper {
      .formatWrapper {
        flex-direction: column;
      }
    }
  }

  /*REQUEST MODAL STYLE*/
  .modalBackground {
    background-color: ${nota.color.neutral.white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: 24px 19px 24px 19px;
    width: 30vw;
    gap: 10px;
    height: auto;
    max-height: 90vh;
    overflow: hidden;

    @media only screen and (max-width: 1450px) {
      width: 50vw;
    }

    @media only screen and (max-width: 800px) {
      width: 80vw;
    }

    .modalContentBlock {
      height: auto;
      overflow: auto;
      padding-bottom: 3px;
      gap: 20px;
      padding: 0 5px;

      .titleBlock {
        height: auto;
        gap: 5px;

        .requirementTitle {
          height: auto;

          h3 {
            color: ${nota.color.neutral.NeuOne};
          }

          b {
            color: ${nota.color.main.default};
            text-transform: uppercase;
          }
        }

        .requirementText {
          height: auto;

          p {
            font-size: 12px;
          }
        }
      }

      .formBlock {
        height: auto;
        gap: 10px;

        .requirementTitle {
          gap: 5px;
        }

        .formRow {
          gap: 16px;

          .form {
            gap: 8px;

            .dropDownContainer {
              width: 100%;

              .inputDropDownWrapper {
                min-width: unset;
              }

              .dropDownContentWrapper {
                max-height: 176px;
              }
            }

            textarea {
              font-family: ${nota.font};
              width: 100%;
              height: 150px;
              overflow: auto;
              border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
              padding: 10px;
              width: 100%;
              font-size: 12px;
              color: ${nota.color.neutral.NeuOne};
              resize: none;
              &::placeholder {
                color: ${nota.color.neutral.NeuTwo};
              }
            }
          }
        }
      }
    }

    .btnsWrapper {
      height: auto;
      gap: 16px;

      button {
        margin: 0;
      }

      .cancelBtn {
        text-decoration: none;
        cursor: pointer;

        .linkText {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          &:hover {
            text-decoration: underline;
            color: ${nota.color.main.default};
          }
        }
      }
    }
  }
  /*END REQUEST MODAL STYLE*/

  /* NOTIFICATION */
  .wrapperNotification {
    background-color: ${nota.color.neutral.white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: 24px 19px 24px 19px;
    width: 30vw;
    gap: 24px;
    height: auto;
    max-height: 80vh;
    overflow: hidden;

    @media only screen and (max-width: 1450px) {
      width: 50vw;
    }

    @media only screen and (max-width: 800px) {
      width: 80vw;
    }
    .iconWrapper {
      padding: 72px 72px 0px 72px;
      svg {
        height: 100px;
        width: auto;
      }
    }
    .infoNotification {
      text-align: center;
      padding: ${multiple * 2 + "px"};
      h3 {
        color: ${nota.color.neutral.NeuOne};
        text-transform: uppercase;
        font-weight: bold;
      }
    }
    .buttonsWrapper {
      height: auto;
    }
    .cancelBtn {
      text-decoration: none;
      cursor: pointer;

      .linkText {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        &:hover {
          text-decoration: underline;
          color: ${nota.color.main.default};
        }
      }
    }
  }
`;

const StyledNoData = styled(NanoFlex)`
  height: calc(100vh - 130px);
  .iconWrapper {
    height: auto;
    margin-bottom: 24px;
    svg {
      height: auto;
      max-width: 344px;
      width: 60%;
      path {
        fill: ${nota.color.neutral.NeuTwo};
      }
    }
  }
  .infoWrapper {
    max-width: 80%;
    height: auto;
    margin-bottom: 8px;
    text-align: center;
    a {
      display: inline-block;
      text-decoration: none;
      margin-left: 4px;
      p {
        color: ${nota.color.main.default};
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledLoading = styled(NanoFlex)`
  height: calc(100vh - 130px);
`;

export class Card extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      idProgram: Number(this.props.render.match.params.id),
      card: null,
      internationalFlow: null,
      audienceResults: null,
      also: null,
      related: null,
      playlists: null,
      hasVideo: null,
      openPlaylistModal: false,
      isLoading: false,
      hasAccess: true,
      showInformationRequest: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onCardLanguageChange, false);
    window.addEventListener("setCardLoading", this.onSetCardLoading, false);
    /*Load Card Data*/
    this.getCardData();
  }

  componentDidUpdate(prevProps, prevState) {
    /* UPDATE CARD PROGRAM DATA ON REDIRECT (match.props.idProgram Changed)*/
    if (prevProps.render.match.params.id !== this.props.render.match.params.id) {
      this.setState(this.getDefaultState());
    }
    if (prevState.idProgram !== this.state.idProgram) {
      this.getCardData();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onCardLanguageChange, false);
    window.removeEventListener("setCardLoading", this.onSetCardLoading, false);
  }

  onCardLanguageChange = () => {
    this.setState(this.getDefaultState(), () => {
      this.getCardData();
    });
  };

  onSetCardLoading = (e) => {
    this.setState({ isLoading: e?.detail ?? false });
  };

  getCardData = () => {
    this.getCard();
    this.getAudienceResults();
    this.getAlso();
    this.getRelated();
    this.getInternationalFlow();
    this.getPlaylists();
  };

  getCard = () => {
    cardService
      .getCard(this.state.idProgram, true)
      .then((response) => {
        if (response.ok) {
          if (response.status === 204) {
            this.setState({ hasAccess: false });
          } else {
            return response.json();
          }
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ card: data, hasVideo: false });
        if (data && data.video) {
          urlExists(data.video, (val) => {
            this.setState({ hasVideo: val });
          });
        }
      });
  };

  getAudienceResults = () => {
    cardService
      .getAudienceResults(this.state.idProgram)
      .then((response) => {
        if (response.ok) {
          if (response.status === 204) return undefined;
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ audienceResults: data });
      });
  };

  getAlso = () => {
    cardService
      .getAlso(this.state.idProgram)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ also: data });
      });
  };

  getRelated = () => {
    cardService
      .getRelated(this.state.idProgram)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ related: data });
      });
  };

  getInternationalFlow = () => {
    cardService
      .getInternationalFlow(this.state.idProgram)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ internationalFlow: data });
      });
  };

  getPlaylists = () => {
    playlistService
      .getPlaylistsByProgram(this.state.idProgram)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlists: data });
      });
  };

  getCardPdf = () => {
    this.setState({ isLoading: true }, () => {
      cardService
        .getCardPdf({ SelectedIds: [this.state.idProgram] })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            // Catch
            if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
          }
          return null;
        })
        .then((blob) => {
          if (blob) {
            downloadBlob(blob, `Programme-Page-${this.state.idProgram}.pdf`);
          }
          this.setState({ isLoading: false });
        });
    });
  };

  registerTagVideoPlay = () => {
    cardService.registerTagVideoPlay(this.state.idProgram).then((response) => {
      if (!response.ok && (response.status === 403 || response.status === 401)) {
        window.dispatchEvent(new Event("sendToLogin"));
      }
      return null;
    });
  };

  registerTagVideoDownload = () => {
    cardService.registerTagVideoDownload(this.state.idProgram).then((response) => {
      if (!response.ok && (response.status === 403 || response.status === 401)) {
        window.dispatchEvent(new Event("sendToLogin"));
      }
      return null;
    });
  };

  onInformationRequestClick = () => {
    this.setState({ showInformationRequest: true });
  };

  onRequestChange = (value) => {
    this.setState({
      request: value.selected.map((v) => {
        return v.id;
      }),
    });
  };

  onIndicatorsChange = (value) => {
    this.setState({ indicators: value?.id });
  };

  onMessageChange = (value) => {
    this.setState({ message: value });
  };

  validateFields = () => {
    let requestError = false;
    // let indicatorsError = false;
    //let messageError = false;
    let isValid = true;
    if (!this.state.request || this.state.request == null) {
      requestError = true;
      isValid = false;
    }
    // if (!this.state.indicators || this.state.indicators == null) {
    //    indicatorsError = true;
    //   isValid = false;
    // }
    // if (!this.state.message || this.state.message.trim() == "") {
    //   messageError = true;
    //   isValid = false;
    // }

    // this.setState({
    //   requestError: requestError,
    //   // indicatorsError: indicatorsError,
    //   messageError: messageError,
    // });

    return isValid;
  };

  sendRequestInformation = () => {
    if (this.validateFields()) {
      this.setState({ isLoading: true }, () => {
        cardService
          .requestInformation({
            launchId: this.state.card.idProgram,
            localTitle: this.state.card.localTitle,
            country: this.state.card.country,
            channel: this.state.card.channel,
            request: this.state.request,
            indicators: this.state.indicators,
            message: this.state.message,
          })
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
          })
          .then((data) => {
            this.setState({ isLoading: false, showInformationRequest: false, successInformationRequest: true, request: null, indicators: null, message: "" });
          });
      });
    }
  };

  render() {
    if (!this.state.hasAccess) {
      return (
        <StyledNoData>
          <NanoFlex flexDirection="column">
            <NanoFlex className="iconWrapper">
              <ErrorLogo />
            </NanoFlex>
            <NanoFlex className="infoWrapper">
              <Type.p>Selected information out of your subscription.</Type.p>
            </NanoFlex>
            <NanoFlex className="infoWrapper" alignContent>
              <Type.p>
                Please contact the
                <a href="mailto:e-nota@glance-mediametrie.com">
                  <Type.p> NoTa Team</Type.p>
                </a>
              </Type.p>
            </NanoFlex>
          </NanoFlex>
        </StyledNoData>
      );
    }

    if (this.state.isLoading || this.state.card === null || this.state.audienceResults === null || this.state.also === null || this.state.internationalFlow === null || this.state.also === null || this.state.related === null || this.state.playlists === null)
      return (
        <StyledLoading className="loadingContainer">
          <Loading />
        </StyledLoading>
      );

    let programmeImageBlock = <ProgrammeImageBlock hasVideo={this.state.hasVideo} card={this.state.card} onVideoPlay={this.registerTagVideoPlay} onVideoDownload={this.registerTagVideoDownload} onInformationRequestClick={this.onInformationRequestClick} />;
    let genreConceptBlock = (
      <GenreConceptBlock
        card={this.state.card}
        isPlaylistActive={this.state.playlists.length > 0}
        onPlaylistClick={() => {
          this.setState({ openPlaylistModal: true });
        }}
        onPdfExportClick={() => {
          this.getCardPdf();
        }}
      />
    );
    let cardInfoBlock = <CardInfoBlock card={this.state.card} />;
    let countryBlock = <CountryBlock card={this.state.card} />;
    let formatTypeBlock = <FormatTypeBlock card={this.state.card} />;
    let internationalFlowBlock = <InternationalFlowBlock internationalFlow={this.state.internationalFlow} selected={this.state.idProgram} />;
    let audienceResultsBlock = <AudienceResultsBlock card={this.state.card} audienceResults={this.state.audienceResults} />;
    let environmentBlock = <EnvironmentBlock card={this.state.card} />;
    let thumbsBlock = <ThumbsBlock related={this.state.related} also={this.state.also} />;
    let sourceBlock = <SourceBlock source={`${this.translation.card.source}: ${this.state.card.source}`} />;
    let evaluationBlock = <EvaluationBlock card={this.state.card} />;
    // let verdictBlock = <VerdictBlock card={this.state.card} />;

    return (
      <StyledCard className="styledCard">
        {!this._isExport && (
          <div>
            {!this._isMobile && (
              <NanoFlex className="cardWrapper" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                {/*COLUMN*/}
                <NanoFlex className="column leftColumn" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                  <NanoFlex className="column-L columnWrapper" flexDirection={"column"}>
                    {/* PROGRAMME CARD IMAGE */}
                    <NanoFlex className="cardImgWrapper" flexDirection={"column"}>
                      {/* PROGRAMME PAGE IMAGE */}
                      {programmeImageBlock}
                      {/* GENRE + CONCEPT */}
                      {genreConceptBlock}
                    </NanoFlex>
                    {/* KEYWORDS & DESCRIPTION */}
                    {cardInfoBlock}
                  </NanoFlex>
                </NanoFlex>
                {/*COLUMN*/}
                <NanoFlex className="column rightColumn" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                  <NanoFlex className="columnWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                    <NanoFlex className="blocksContainer" flexDirection={"column"}>
                      {/* COUNTRY BLOCK */}
                      {countryBlock}
                      {/* FORMAT TYPE BLOCK */}
                      {formatTypeBlock}
                    </NanoFlex>
                    {/* INTERNATIONAL FLOW */}
                    {internationalFlowBlock}
                    {/* AUDIENCE RESULTS */}
                    {audienceResultsBlock}
                    {/* ENVIRONMENT BLOCK */}
                    {environmentBlock}
                    {/* EVALUATION BLOCK */}
                    {evaluationBlock}
                    {/* VERDICT BLOCK */}
                    {/* {verdictBlock} */}
                    {/* THUMBS BLOCK */}
                    {thumbsBlock}
                    {/* SOURCE */}
                    {sourceBlock}
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            )}

            {this._isMobile && (
              <NanoFlex className="cardWrapper" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                {/*COLUMN*/}
                <NanoFlex className="column" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                  <NanoFlex className="column-L columnWrapper" flexDirection={"column"}>
                    {/* PROGRAMME PAGE IMAGE */}
                    {programmeImageBlock}
                    {/* COUNTRY BLOCK */}
                    {countryBlock}
                    {/* GENRE + CONCEPT */}
                    {genreConceptBlock}
                    {/* FORMAT TYPE BLOCK */}
                    {formatTypeBlock}
                    {/* INTERNATIONAL FLOW */}
                    {internationalFlowBlock}
                    {/* KEYWORDS & DESCRIPTION */}
                    {cardInfoBlock}
                    {/* AUDIENCE RESULTS */}
                    {audienceResultsBlock}
                    {/* ENVIRONMENT BLOCK */}
                    {environmentBlock}
                    {/* EVALUATION BLOCK */}
                    {evaluationBlock}
                    {/* VERDICT BLOCK */}
                    {/* {verdictBlock} */}
                    {/* THUMBS BLOCK */}
                    {thumbsBlock}
                    {/* SOURCE */}
                    {sourceBlock}
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            )}
            <Modal
              show={this.state.openPlaylistModal}
              content={
                <PlaylistModal
                  mode={"ReplaceByProgram"}
                  ignoreConfirmValidation={true}
                  selectedPlaylists={this.state.playlists.map((v) => v.id)}
                  filter={{ SelectedIds: [this.state.idProgram] }}
                  cancelAction={() => {
                    this.setState({ openPlaylistModal: false });
                  }}
                  nextAction={() => {
                    this.setState({ openPlaylistModal: false }, () => {
                      /*Get Playlists after saving */
                      this.getPlaylists();
                    });
                  }}
                />
              }
            />
          </div>
        )}
        {this._isExport && (
          <div>
            <NanoFlex className="cardWrapper" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
              {/*COLUMN*/}
              <NanoFlex className="column leftColumn" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                <NanoFlex className="column-L columnWrapper" flexDirection={"column"}>
                  {/* PROGRAMME CARD IMAGE */}
                  <NanoFlex className="cardImgWrapper" flexDirection={"column"}>
                    {/* PROGRAMME PAGE IMAGE */}
                    {programmeImageBlock}
                  </NanoFlex>
                  {/* COUNTRY BLOCK */}
                  {countryBlock}
                  {/* FORMAT TYPE BLOCK */}
                  {formatTypeBlock}
                </NanoFlex>
              </NanoFlex>
              {/*COLUMN*/}
              <NanoFlex className="column rightColumn" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
                <NanoFlex className="columnWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                  <NanoFlex className="blocksContainer" flexDirection={"column"}></NanoFlex>
                  {/* GENRE + CONCEPT */}
                  {genreConceptBlock}
                  {/* KEYWORDS & DESCRIPTION */}
                  {cardInfoBlock}
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex flexDirection={"column"}>
              {/* AUDIENCE RESULTS */}
              {audienceResultsBlock}
              {/* ENVIRONMENT BLOCK */}
              {environmentBlock}
              {/* EVALUATION BLOCK */}
              {evaluationBlock}
              {/* VERDICT BLOCK */}
              {/* {verdictBlock} */}
            </NanoFlex>
            {/* INTERNATIONAL FLOW */}
            {internationalFlowBlock}
            <NanoFlex>
              {/* SOURCE */}
              {sourceBlock}
            </NanoFlex>
          </div>
        )}

        <Modal
          show={this.state.showInformationRequest}
          content={
            <NanoFlex className="modalBackground" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
              <NanoFlex className="modalContentBlock" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <NanoFlex className="titleBlock" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                  <NanoFlex className="requirementTitle" justifyContent="flex-start">
                    <Type.h4>
                      <b>Nota</b> Analysis Request
                    </Type.h4>
                  </NanoFlex>
                  <NanoFlex className="requirementText" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                    <Type.p>Want to know more about this programme?</Type.p>
                    <Type.p>You can request additional information by filling out the form below.</Type.p>
                    <Type.p>Depending on your subscription, this may be included or you may be asked to pay an additional fee.</Type.p>
                    <Type.p>Either way, we'll get back to you soon!</Type.p>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="formBlock" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                  <NanoFlex className="requirementTitle" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                    <Type.h4>
                      <b>{this.state.card.localTitle}</b>
                    </Type.h4>
                    <Type.h4>
                      {this.state.card.country} - {this.state.card.channel}
                    </Type.h4>
                  </NanoFlex>

                  <NanoFlex className="formRow" justifyContent="flex-start">
                    <NanoFlex className="form" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                      <Type.p style={{ color: this.state.requestError ? nota.color.main.mTwo : nota.color.main.defaultTwo }}>Request</Type.p>
                      <MultiSelectionDropdown
                        error={this.state.requestError}
                        options={[
                          { id: 1, name: "Additional performances of the programme" },
                          { id: 2, name: "Tracking of the programme broadcasts" },
                          { id: 3, name: "Competition analysis" },
                          { id: 4, name: "Channel contextual analysis" },
                          { id: 5, name: "Content evaluation" },
                          { id: 6, name: "Additional video elements" },
                          { id: 7, name: "Other information request" },
                        ]}
                        onChangeSelection={this.onRequestChange}
                      />
                    </NanoFlex>
                    {/*<NanoFlex className="form" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">*/}
                    {/*  <Type.p style={{ color: this.state.indicatorsError ? nota.color.main.mTwo : nota.color.main.defaultTwo }}>Indicators</Type.p>*/}
                    {/*  <SingleSelectionDropdown*/}
                    {/*    error={this.state.indicatorsError}*/}
                    {/*    options={[*/}
                    {/*      { id: 1, name: "Rat% / Rat 000 / Msh%" },*/}
                    {/*      { id: 2, name: "Other" },*/}
                    {/*    ]}*/}
                    {/*    onChangeSelection={this.onIndicatorsChange}*/}
                    {/*  />*/}
                    {/*</NanoFlex>*/}
                  </NanoFlex>

                  <NanoFlex className="formRow" justifyContent="flex-start">
                    <NanoFlex className="form" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                      <Type.p style={{ color: this.state.messageError ? nota.color.main.mTwo : nota.color.main.defaultTwo }}>Message</Type.p>
                      <textarea
                        style={{ border: `1px solid ${this.state.messageError ? nota.color.main.mTwo : nota.color.neutral.NeuTwo}` }}
                        onChange={(e) => {
                          this.onMessageChange(e.target.value);
                        }}></textarea>
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
              <NanoFlex className="btnsWrapper">
                <Button label="Confirm" clickAction={this.sendRequestInformation}></Button>
                <a className="cancelBtn" onClick={() => this.setState({ showInformationRequest: false })}>
                  <Type.p className="linkText">Cancel</Type.p>
                </a>
              </NanoFlex>
            </NanoFlex>
          }
        />

        <Modal
          show={this.state.successInformationRequest}
          content={
            <NanoFlex className="wrapperNotification" flexDirection="column">
              <NanoFlex className="iconWrapper">
                <Check />
              </NanoFlex>

              <NanoFlex className="infoNotification">
                <Type.h3>Your email was sent successfully!</Type.h3>
              </NanoFlex>
              <NanoFlex className="buttonsWrapper" flexDirection="column">
                <a className="cancelBtn" onClick={() => this.setState({ successInformationRequest: false })}>
                  <Type.p className="linkText">Close</Type.p>
                </a>
              </NanoFlex>
            </NanoFlex>
          }
        />
      </StyledCard>
    );
  }
}
